import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import {
    ChangeFeedFilterRatePayload,
    changeFeedFiltersRate
} from '../../actions/feed-filters/rate-form';
import {
    FeedFilterRateForm,
    FeedFilterRateFormProps
} from '../../components/FeedFilterRateForm/FeedFilterRateForm';
import { FeedFilterRateType } from '../../typings/feedFilters';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

interface OwnProps {
    isLoading: boolean;
    hasNote?: boolean;
    fixedRateType?: FeedFilterRateType;
    onCancel: () => void;
    onSave: (rateType: FeedFilterRateType, rate?: number) => void;
}

type StateProps = TStateProps<FeedFilterRateFormProps, OwnProps>;

type DispatchProps = TDispatchProps<FeedFilterRateFormProps, OwnProps>;

const mapStateToProps = (state: State) => {
    const {
        commonData,
        feedFilters: { rateForm }
    } = state;
    const currency = commonData.client.workCurrency;
    const { rateType, rate, errors } = rateForm;

    return {
        currency,
        rateType,
        rate,
        rateErrors: errors
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        onRateChange(payload: ChangeFeedFilterRatePayload) {
            dispatch(changeFeedFiltersRate(payload));
        }
    };
};

export const FeedFilterRateFormContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps
>(
    mapStateToProps,
    mapDispatchToProps
)(FeedFilterRateForm);
